// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlogCard_blog-card__FasVV {
  background-color: #ffffff;
  border: 1px solid #5b5b5b;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.BlogCard_blog-card__FasVV:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}
.BlogCard_blog-card__media-wrapper__5M42Q {
  width: 100%;
  background-color: #000;
  border-radius: 16px;
}
.BlogCard_blog-card__media__jTdSm {
  width: 100%;
  display: block;
  height: auto;
  border-radius: 16px;
}
.BlogCard_blog-card__content__F5xNr {
  padding: 24px 13px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.BlogCard_blog-card__title__JPVrK {
  font-size: 1.55rem;
  font-weight: 400;
  color: #000000;
  margin: 0 0 0.35rem 0;
}
.BlogCard_blog-card__description__xOfxq {
  font-size: 1.25rem;
  color: #2D2D2F;
  line-height: 1;
  margin: 0 0 1.5rem 0;
  flex-grow: 1;
}
.BlogCard_blog-card__link__6ChXq {
  color: #2D2D2F;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.3s ease;
  align-self: flex-start;
  margin-left: 10px;
  font-size: 1.2rem;
}
.BlogCard_blog-card__link__6ChXq:hover {
  color: #FE5F55;
}`, "",{"version":3,"sources":["webpack://./src/components/Landing/BlogSection/BlogCard.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,qDAAA;AACF;AACE;EACE,2BAAA;EACA,0CAAA;AACJ;AAEE;EACE,WAAA;EACA,sBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;AADJ;AAIE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAFJ;AAKE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAHJ;AAME;EACE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;AAJJ;AAOE;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;AALJ;AAOI;EACE,cAAA;AALN","sourcesContent":[".blog-card {\n  background-color: #ffffff;\n  border: 1px solid #5b5b5b;\n  border-radius: 20px;\n  overflow: hidden; \n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n\n  &:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n  }\n\n  &__media-wrapper {\n    width: 100%;\n    background-color: #000; \n    border-radius: 16px;\n  }\n  \n  &__media {\n    width: 100%;\n    display: block;\n    height: auto;\n    border-radius: 16px;\n  }\n  \n  &__content {\n    padding: 24px 13px;\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n  }\n  \n  &__title {\n    font-size: 1.55rem;\n    font-weight: 400;\n    color: #000000;\n    margin: 0 0 0.35rem 0;\n  }\n  \n  &__description {\n    font-size: 1.25rem;\n    color: #2D2D2F;\n    line-height: 1;\n    margin: 0 0 1.5rem 0;\n    flex-grow: 1;\n  }\n  \n  &__link {\n    color: #2D2D2F;\n    font-weight: 600;\n    text-decoration: none;\n    transition: color 0.3s ease;\n    align-self: flex-start;\n    margin-left: 10px;\n    font-size: 1.2rem;\n\n    &:hover {\n      color: #FE5F55; \n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blog-card": `BlogCard_blog-card__FasVV`,
	"blog-card__media-wrapper": `BlogCard_blog-card__media-wrapper__5M42Q`,
	"blog-card__media": `BlogCard_blog-card__media__jTdSm`,
	"blog-card__content": `BlogCard_blog-card__content__F5xNr`,
	"blog-card__title": `BlogCard_blog-card__title__JPVrK`,
	"blog-card__description": `BlogCard_blog-card__description__xOfxq`,
	"blog-card__link": `BlogCard_blog-card__link__6ChXq`
};
export default ___CSS_LOADER_EXPORT___;
